import React from "react";
import routeGuard from "src/Hooks/routeGuard";
import ProjectInstanceList from "src/components/ProjectInstance";
import { RESOURCE_TYPE } from "src/constant/common";

const ProjectInstance = () => {
  return <ProjectInstanceList />;
};
export default routeGuard(ProjectInstance, RESOURCE_TYPE.PROJECT_INSTANCE);
